import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';


export const StyledSidebarLayout = styled(Box)(() => ({
  '.main-header': {
    '.leftNavSec': {
      display: 'flex',
      alignItems: 'center',
      gap: "20px",
      marginLeft: "auto",
      '.nav-link': {
        outline: "none",
      },
      '.nav-item': {
        outline: "none",
      },
      '.icon': {
        '.badgeIcon': {
          'img': {
            fontSize: "24px",
            cursor: "pointer",
          },
          '.MuiBadge-badge': {
            minWidth: "inherit",
            width: "20px",
            height: "20px",
            backgroundColor: "#FF4B23FC",
            fontSize: "11px",
            fontWeight: "400",
            left: "3px",
            top: "4px",
          }
        },
      }
    }
  },
  '.brand-link': {
    display: 'flex',
    justifyContent: 'center',
    border: 'none',
    '.logo': {
      width: '170px',
    }
  },

  '.sidebar': {

    '.nav-item': {
      '.nav-link': {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "400",
        padding: "12px 20px",
        borderRadius: "10px",
        marginBottom: "15px",
        width: "100%",
        ".icon-size": {
          width: '20px',
          marginRight: "30px"
        }
      },
      '.nav-link.active': {
        backgroundColor: "#3F30FF",
        fontWeight: "600",
        boxShadow: "none",
      }
    }
  },


}));

export default StyledSidebarLayout;

